<script>
import store from "../../../vuex/store";

export const PER_PAGE = 10;

export default {
  props: {
    allDataLength: Number,
  },
  data() {
    return {
      page: 1,
      perPage: PER_PAGE,
    };
  },

  watch: {
    chosenWidget: {
      handler: "resetPagination",
      immediate: true,
      deep: true,
    },
  },
  computed: {
    chosenWidget() {
      return store.state.users.chosenWidget;
    },

    allData() {
      return this.$props.allDataLength;
    },
    totalPagesCount() {
      return Math.ceil(this.allData / this.perPage);
    },
    nextPageDisabled() {
      return this.page === this.totalPagesCount ? true : false;
    },
    prevPageDisabled() {
      return this.page === 1 ? true : false;
    },
    skip() {
      return this.perPage * (this.page - 1);
    },
    visibleData() {
      return { skip: this.skip, length: this.perPage * this.page };
    },
  },
  methods: {
    resetPagination() {
      this.page = 1;
      this.perPage = PER_PAGE;
    },

    emitData() {
      this.$emit("updateVisibleData", this.visibleData);
    },

    async getPage(type) {
      type === "next" ? this.page++ : this.page--;
      this.emitData();
    },

    async getEndPage(type) {
      type === "last" ? (this.page = this.totalPagesCount) : (this.page = 1);
      this.emitData();
    },
  },

  mounted() {
    this.page = 1;
    this.perPage = PER_PAGE;
  },
};
</script>

<template>
  <div v-show="totalPagesCount > 1" class="links__buttons-box">
    <p class="pages__count">Page {{ page }} of {{ totalPagesCount }}</p>

    <div class="links__navigation-box">
      <button
        @click="getEndPage('first')"
        :disabled="prevPageDisabled"
        class="links__button"
      >
        <svg class="links__button-icon">
          <use xlink:href="@/assets/icons/toListEnd.svg#toListEnd"></use>
        </svg>
        <span>First</span>
      </button>

      <button
        @click="getPage('prev')"
        :disabled="prevPageDisabled"
        class="links__button"
      >
        <svg class="links__button-icon">
          <use xlink:href="@/assets/icons/prev.svg#prev"></use>
        </svg>
        <span>Previous</span>
      </button>

      <button
        @click="getPage('next')"
        :disabled="nextPageDisabled"
        class="links__button links__button--icon_horizontal_flip"
      >
        <span>Next</span>
        <svg class="links__button-icon links__button-icon--horizontal_flip">
          <use xlink:href="@/assets/icons/prev.svg#prev"></use>
        </svg>
      </button>

      <button
        @click="getEndPage('last')"
        :disabled="nextPageDisabled"
        class="links__button links__button--icon_horizontal_flip"
      >
        <span>Last</span>
        <svg class="links__button-icon links__button-icon--horizontal_flip">
          <use xlink:href="@/assets/icons/toListEnd.svg#toListEnd"></use>
        </svg>
      </button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.links__buttons-box,
.links__navigation-box {
  display: flex;
  align-items: center;
  gap: 16px;
}

.links__buttons-box {
  align-items: center;

  @media screen and (min-width: 1024px) {
    width: 650px;
    justify-content: space-between;
  }

  @media screen and (max-width: 768px) {
    flex-direction: column;
  }
}

.pages__count {
  margin: 0;
  padding: 0;
  color: #4f4f4f;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 1;
}

.links__button {
  display: flex;
  padding: 4px 8px;
  justify-content: center;
  align-items: center;
  gap: 6px;
  border-radius: 6px;
  border: 1px solid #c4c4c4;
  background: transparent;
  transition: all ease-in-out 300ms;
  color: #000;
  fill: #000;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.71;

  &:hover {
    color: #3056d3;
    fill: #3056d3;
    border-color: #3056d3;
  }

  &:disabled {
    opacity: 0.5;

    &:hover {
      border: 1px solid #c4c4c4;
      color: #000;
      fill: #3056d3;
    }
  }

  @media screen and (min-width: 769px) {
    width: 106px;
  }

  @media screen and (max-width: 768px) {
    display: inline-flex;
  }

  & > span {
    @media screen and (max-width: 768px) {
      display: none;
    }
  }
}

.links__button-icon {
  fill: inherit;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.links__button-icon--horizontal_flip {
  transform: scaleX(-1);
}
</style>
